document.addEventListener('DOMContentLoaded', function() {
  const targetButton = document.querySelector('.cart-bottom-no-sticky.pdp-custom-page button.o-button--primary--new-customer');
  const pdpPage = document.querySelector('.pdp-custom-page');
  const buttonBackgroundOverlay = document.querySelector('.button-background-overlay');
  if (targetButton && pdpPage) {
    const initialButtonTop = targetButton.offsetTop;

    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop >= initialButtonTop) {
        pdpPage.classList.remove('cart-bottom-no-sticky');
        if (buttonBackgroundOverlay) {
          buttonBackgroundOverlay.style.display = 'block';
        }
      } else {
        pdpPage.classList.add('cart-bottom-no-sticky');
        if (buttonBackgroundOverlay) {
          buttonBackgroundOverlay.style.display = 'none';
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();
  }
});